import { JSX } from "react";
import { User } from "../../../app/backendTypes";
import { useApprover } from "../../../app/hooks";

function ApproverLoader(props: {
  taskId: string;
  approvalIndex: number;
  render: (user: User, reload: () => void) => JSX.Element;
  renderError?: (error: string, reload: () => void) => JSX.Element;
  renderLoading?: () => JSX.Element;
  skipLoading: boolean;
}) {
  const {
    taskId,
    approvalIndex,
    render,
    renderError,
    renderLoading,
    skipLoading,
  } = props;

  const { approver, error, loading, reload } = useApprover(
    taskId,
    approvalIndex,
    skipLoading
  );

  let comp = <></>;

  if (loading) {
    if (renderLoading !== undefined) {
      comp = renderLoading();
    }
  } else if (error) {
    if (renderError !== undefined) {
      comp = renderError(error, reload);
    }
  } else if (approver !== null) {
    comp = render(approver, reload);
  }

  return comp;
}

export default ApproverLoader;
